import { documentService } from "../../../services/api.documents";
import { documentConstants } from "../../constants";

export const viewActions = {
  getUnviewedCount
};

function getUnviewedCount(params) {
  return (dispatch) => {
    dispatch(request());

    documentService.getUnviewedCount(params).then(
      (response) => dispatch(success(response)),
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка при получении истории просмотров",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request() {
    return { type: documentConstants.DOCUMENTS_UNVIEWED_COUNT_REQUEST };
  }
  function success(response) {
    return { type: documentConstants.DOCUMENTS_UNVIEWED_COUNT_SUCCESS, response };
  }
  function failure(error) {
    return { type: documentConstants.DOCUMENTS_UNVIEWED_COUNT_FAILURE, error };
  }
}